import {isAvailableDonationTicket} from '@wix/wix-events-commons-statics'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {getPlaceInfoItems, isPlaceArea} from '../../../../../../selectors/seating/place'
import {LabelWithValue} from '../../../../../common/label-with-value'
import {TicketFees} from '../../ticket-fees'
import {TicketPrice} from '../../ticket-price'
import {TicketInfoTextsProps} from './interfaces'
import {classes} from './ticket-info-texts.st.css'

export const TicketInfoTexts = ({
  place,
  inPopover,
  inDrawer,
  inPricingOptionsModal,
  forcePricingOptionRangeLabel,
}: TicketInfoTextsProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const area = isPlaceArea(place)

  const placeInfo = getPlaceInfoItems(place, t)
  const ticketName = place.ticket?.name

  const hideName = area && inPricingOptionsModal && isMobile

  const hidePrice =
    (place.ticket && isAvailableDonationTicket(place.ticket) && !inPopover && !inDrawer) || inPricingOptionsModal

  return (
    <div className={classes.container}>
      <div className={classNames(classes.infoContainer, {[classes.paddingRight]: !inPopover})}>
        {placeInfo.map(({label, value}, index) => (
          <LabelWithValue key={index} labelClassName={classes.label} label={label} value={value} />
        ))}
      </div>
      {hideName && hidePrice ? null : (
        <div className={classes.ticketInfo}>
          {hideName ? null : <Text className={classes.ticketName}>{ticketName}</Text>}
          {hidePrice ? null : (
            <>
              <TicketPrice
                forcePricingOptionRangeLabel={forcePricingOptionRangeLabel}
                place={place}
                inPopover={inPopover}
                inDrawer={inDrawer}
              />
              <TicketFees forceAbstractFees={forcePricingOptionRangeLabel} place={place} inPopover={inPopover} />
            </>
          )}
        </div>
      )}
    </div>
  )
}
